import React from 'react';
import { compose } from 'recompose';
import Layout from '../utils/layout';
import { graphql } from 'gatsby';
import {
  withAuthorization,
  withEmailVerification,
} from '../utils/Session';
import Plan from '../components/scenes/Plan/Plan';

const condition = authUser => !!authUser;
const PlanPage = compose(
  withEmailVerification,
  withAuthorization(condition),
)(Plan);

export default () => {
  return (
    <Layout>
      <PlanPage />
    </Layout>
  );
};

export const query = graphql`
  query PlanSeo {
    site {
      siteMetadata {
        home {
          defaultTitle: title
          titleTemplate
          defaultDescription: description
          siteUrl: url
          defaultImage: image
          twitterUsername
        }
      }
    }
  }
`;
